import React from "react";
import StudyBuddyPracticeV2Page from "./StudyBuddyPracticeV2Page";
import useStudyBuddyIframeHeight from "./useStudyBuddyIframeHeight";

export default function StudyBuddyPracticeV2EmbedPage(){const heightRef=useStudyBuddyIframeHeight();return <div ref={heightRef}><StudyBuddyPracticeV2Page embed/></div>;}
